module.exports = __webpack_public_path__ + "static/media/1.db1eb372.jpg";